import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import {
  loadCustomerListCompletion,
  loadCustomerCompletion,
} from '../../actions';

export function* watchLoadCustomerList() {
  yield takeEvery('LOAD_CUSTOMER_LIST', function*({
    range,
    sort,
    desc,
    keyword = '',
  }) {
    const options = {
      url: `/api/b/customer/list?start=${range.location}&size=${range.length}&sort=${sort}&desc=${desc}&keyword=${keyword}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadCustomerListCompletion(range, result.data, result.error));
  });
}

export function* watchLoadCustomer() {
  yield takeEvery('LOAD_CUSTOMER', function*({ customerId }) {
    const options = {
      url: `/api/b/customer/${customerId}/detail`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadCustomerCompletion(customerId, result.data, result.error));
  });
}

export default function* customerSaga() {
  yield all([fork(watchLoadCustomerList), fork(watchLoadCustomer)]);
}
